import api from "./axios";

const dashboardAPI = {

    async getStatistics() {

        const response = await api.get("/dashboard/stats");

        return response.data;

    },

    async getRecentActivity() {

        const response = await api.get("/dashboard/activity");

        return response.data;

    },

    async getSyncStatus() {

        const response = await api.get("/dashboard/sync");

        return response.data;

    },

    async syncGoogleDrive() {

        const response = await api.post("/google/sync");

        return response.data;

    }

};

export default dashboardAPI;